var _circle, _ellipse, _path, _path2, _circle2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTuser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8271,
    cy: 14.6591,
    r: 3.40909,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.37393,
    cy: 14.6591,
    rx: 3.40909,
    ry: 3.40909,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6001 28.9772V24.2045C33.6001 21.5686 31.4633 19.4318 28.8274 19.4318V19.4318C26.1915 19.4318 24.0547 21.5686 24.0547 24.2045V28.9772",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.147 28.9772V24.2045C13.147 21.5686 11.0102 19.4318 8.37429 19.4318V19.4318C5.73839 19.4318 3.60156 21.5686 3.60156 24.2045V28.9772",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5992,
    cy: 11.0552,
    r: 3.8961,
    fill: "#03F5AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0575 30.3408V22.159C24.0575 19.1466 21.6154 16.7045 18.603 16.7045V16.7045C15.5905 16.7045 13.1484 19.1466 13.1484 22.159V30.3408",
    stroke: "#03F5AE",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuser);
export default __webpack_public_path__ + "static/media/tuser.872fde6e8bdcc0363e01adf44eeb56db.svg";
export { ForwardRef as ReactComponent };